import { BasicRequest } from "./basicRequest";

export class RunFailedMoovStepInstanceRequest extends BasicRequest{
    public moovStepInstanceId!:number;

    constructor(){
        super();
    }
}